module.exports = __webpack_public_path__ + "static/media/svg_3_2_1_E24.f1529dd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/03/02/assets/svg_3_2_1_E24.svg
// module id = 494
// module chunks = 0